import { render } from "./ProcessoResumoModal.vue?vue&type=template&id=7abb98dc&scoped=true"
import script from "./ProcessoResumoModal.vue?vue&type=script&lang=js"
export * from "./ProcessoResumoModal.vue?vue&type=script&lang=js"

import "./ProcessoResumoModal.vue?vue&type=style&index=0&id=7abb98dc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abb98dc"]])

export default __exports__